<template>
  <div class="content-main">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title-index">
          <h2>Mapa IED</h2>
          <v-btn icon @click="showModal" style="background: #000; color: #fff">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          v-model="region"
          :options="regions"
          label="label"
          placeholder="REGIÃO"
          @input="onChangeRegions"
          class="grafico-select"
          :disabled="disabelRegions"
          :loading="loading"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          v-model="state"
          :options="states"
          label="uf"
          placeholder="UF"
          @input="onChangeStates"
          class="grafico-select"
          :disabled="disableStates"
          :loading="loading"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          v-model="macroRegion"
          multiple
          :options="macroRegions"
          label="uf"
          placeholder="MACRO REGIÃO"
          @input="onChangeMacroRegion"
          class="grafico-select"
          :disabled="disableMacroRegion"
          :loading="loading"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          v-model="regionalValue"
          multiple
          :options="regional"
          label="REGIONAL"
          placeholder="REGIONAL"
          @input="onChangeRegional"
          class="grafico-select"
          :disabled="disableRegional"
          :loading="loading"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4 col-12">
        <vue-select
          v-model="city"
          :options="optionsCities"
          label="Município"
          placeholder="MUNICÍPIO"
          @input="onChangeCities"
          class="grafico-select"
          :disabled="disableCities"
          :loading="loading"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-12 mapa">
        <l-map
          :zoom.sync="zoom"
          :center="center"
          style="height: 700px; width: 100%"
          ref="map"
          :options="{ zoomControl: false }"
        >
          <l-tile-layer :url="url" :attribution="attribution" />
          <l-control-zoom position="bottomright"></l-control-zoom>
          <template v-for="item in dados">
            <div :key="item.key">
              <l-circle-marker
                :lat-lng="[item?.latitude, item?.longitude]"
                :radius="10"
                :color="getColor(item?.ied !== '' && item ? item?.ied : '')"
                :fillColor="getColor(item?.ied !== '' && item ? item?.ied : '')"
                :stroke="false"
                :fillOpacity="0.6"
              >
                <l-tooltip>
                  <div class="tooltip-latlgn">
                    <strong>{{ item.no_municipio }} - {{ item.no_uf }}</strong>
                    <br />
                    <span> População: {{ item.populacaoIBGE }} </span>
                    <br />
                    <span> Porte: {{ item.faixa_populacional }} </span>
                    <br />
                    <span> IVS: {{ item.ivs }}</span>
                    <br />
                    <span> IED: {{ item.ied }}</span>
                  </div>
                </l-tooltip>
              </l-circle-marker>
            </div>
          </template>
        </l-map>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-xl-6 col-lg-6">
        <div class="caption-map">
          <div
            v-for="(item, index) in ieds"
            :key="index"
            :class="'caption-item caption-' + item.color"
          >
            <span></span>
            <h4>
              {{ item.label }}
            </h4>
          </div>
        </div>
      </div>
      <!-- <div
        class="d-flex justify-content-end col-12 col-sm-6 col-md-6 col-xl-6 col-lg-6"
      >
        <div class="form-check" style="margin-top: 7px">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="comEsus"
            value=""
            id="flexCheckDefault"
          />
          <label class="form-check-label" for="flexCheckDefault">
            Com eSUS Feedback
          </label>
        </div>
      </div> -->
      <!-- modal -->
      <b-modal
        v-model="modalAjuda.enabled"
        id="bv-modal-notification"
        size="xl"
        hide-footer
        centered
        scrollable
      >
        <div v-html="modalAjuda.text"></div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { coordinatesStates, coordinatesRegions } from '../utils/coordinates.js'
import { statesBR } from '../utils/states.js'
import { infoHtml } from './utils/ajuda.js'

export default {
  name: 'MapaIed',
  components: {
    PulseLoader,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    'vue-select': VueSelect,
  },
  data() {
    return {
      comEsus: false,
      steps: '',
      zoom: 5,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      icon: icon({
        iconUrl: require('@/assets/icones/iconemapa2.png'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      staticAnchor: [16, 37],
      customText: 'Foobar',
      iconSize: 64,

      regions: [
        {
          value: 'sul',
          label: 'Sul',
        },
        {
          value: 'sudeste',
          label: 'Sudeste',
        },
        {
          value: 'norte',
          label: 'Norte',
        },
        {
          value: 'nordeste',
          label: 'Nordeste',
        },
        {
          value: 'centro-oeste',
          label: 'Centro-Oeste',
        },
      ],
      disableIndicador: true,
      /*     indicador: '', */
      ieds: [
        {
          label: 'IED = 1',
          color: 'red',
        },
        {
          label: 'IED = 2',
          color: 'orange',
        },
        {
          label: 'IED = 3',
          color: 'yellow',
        },
        {
          label: 'IED = 4',
          color: 'green',
        },
      ],
      region: [],
      population: [],
      populations: [
        {
          value: 'de 50.001 a 100.000',
          label: 'de 50.001 a 100.000',
        },
        {
          value: 'de 5.001 a 10.000',
          label: 'de 5.001 a 10.000',
        },
        {
          value: 'de 20.001 a 50.000',
          label: 'de 20.001 a 50.000',
        },
        {
          value: 'de 100.001 a 500.000',
          label: 'de 100.001 a 500.000',
        },
        {
          value: 'de 10.001 a 20.000',
          label: 'de 10.001 a 20.000',
        },
        {
          value: 'até 5.000',
          label: 'até 5.000',
        },
        {
          value: 'acima de 500.000 hab.',
          label: 'acima de 500.000 hab.',
        },
      ],
      dataIsf: [
        {
          value: 'ISF < 4,0',
          label: 'ISF < 4,0',
        },
        {
          value: 'ISF > 3,9 e < 7,0',
          label: 'ISF > 3,9 e < 7,0',
        },
        {
          value: 'ISF > 6,9 e < 10,0',
          label: 'ISF > 6,9 e < 10,0',
        },
        {
          value: 'ISF  = 10,0',
          label: 'ISF = 10,0',
        },
      ],
      state: '',
      states: [],
      city: null,
      optionsCities: [],
      optionsCitiesOrigins: [],
      disableCities: true,
      /*     states: [...statesBR], */
      macroRegion: [],
      macroRegions: [],
      regional: [],
      regionalValue: '',
      isf: [],
      markersFilter: [],
      dataToFilter: [],
      disabelRegions: false,
      disableStates: true,
      disablePopulation: false,
      disableMacroRegion: true,
      disableRegional: true,
      disableIsf: true,
      dataFilterCitiesRegion: [],
      dataFilterPopulation: [],
      dataFilterMacroRegions: [],
      dataFilterRegional: [],
      dataFilterIsf: [],
      info: {
        type: 'municipio',
        title:
          'Os primeiros da lista são municípios com melhor desempenho, ou seja, ISF mais alto.',
      },
      dados: [],
      dadosOriginaisDaRequisicao: [],
      nomeMunicipio: '',
      loading: false,
      loadingPdf: false,
      municipio: '',
      quadrimestre: '',
      quadrimestres: [],
      temEstadoSelecionado: false,
      modalAjuda: {
        enabled: true,
        text: infoHtml,
      },
      openedModalSeloAps: false,
      openedModalPorcentagem: false,
      seloApsImg: '',
      porcentagemImg: '',
      loading: false,
    }
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15]
    },
  },
  async mounted() {},
  methods: {
    showModal() {
      this.modalAjuda.enabled = true
    },
    getCoordinates(isRegion = false) {
      setTimeout(() => {
        let selectedCoordinates
        if (isRegion) {
          // pega as coordenadas da região
          const regionCoordinates = coordinatesRegions.find((item) => {
            return item.region === this.region.label
          })
          selectedCoordinates = regionCoordinates
        } else {
          // pega as coordenadas do estado
          const stateCoordinates = coordinatesStates.find((item) => {
            return item.uf === this.state
          })
          selectedCoordinates = stateCoordinates
        }

        const mapObject = this.$refs.map.mapObject
        mapObject.setView(
          latLng(selectedCoordinates.lat, selectedCoordinates.lgn),
          selectedCoordinates.zoom
        )
      }, 500)
    },

    filter(
      dataFilterCitiesRegion,
      dataFilterCity,
      dataFilterPopulation,
      dataFilterMacroRegions,
      dataFilterRegional
    ) {
      let data = []
      data = this.dadosOriginaisDaRequisicao
      // Busca todas cidades da região
      if (dataFilterCitiesRegion.length > 0) {
        data = this.allCitiesInRegion(dataFilterCitiesRegion)
      }

      // busca todas as cidades do estado

      if (this.state !== '') {
        data = this.allCitiesByState(this.state)
      }

      // Filtra por cidade
      if (dataFilterCity !== null) {
        data = this.cityFilter(data)
      }

      // filtra por população
      if (dataFilterPopulation.length > 0) {
        data = this.citiesByPopulation(dataFilterPopulation)
      }

      // filtra por macro região
      if (dataFilterMacroRegions.length > 0) {
        data = this.citiesByMacroRegions(
          data,
          this.state,
          dataFilterMacroRegions
        )
      }

      // filtra por regional
      if (dataFilterRegional.length > 0) {
        data = this.citiesByRegional(data, this.state, dataFilterRegional)
      }

      // Tira os dados sem localização
      data = data.filter((item) => {
        return (
          item?.latitude != '0' &&
          item?.latitude != null &&
          item?.latitude != undefined &&
          item?.latitude != '' &&
          item?.longitude != '0' &&
          item?.longitude != null &&
          item?.longitude != undefined &&
          item?.longitude != ''
        )
      })

      this.dados = data
    },

    async onChangeRegions(event) {
      this.dados = []
      this.dadosOriginaisDaRequisicao = []
      this.disableIndicador = true
      this.comEsus = false
      this.city = null
      if (event !== null) {
        this.steps = 'regiao'
        this.disableStates = false
        this.state = ''
        this.states = []
        this.regionalValue = ''
        this.regional = []
        this.macroRegion = []
        this.macroRegions = []
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterCity = null
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []
        this.region = event
        // Busca todos os dados
        await this.allCities()

        const dataUf = []
        dataUf.push(event.value)

        const data = statesBR.filter((item) => {
          return dataUf.includes(item.region)
        })

        this.states = data

        this.dataFilterCitiesRegion = data.map((element) => {
          return element.uf
        })

        // pega as coordenadas da região
        this.getCoordinates(true)
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = ''
        this.state = ''
        this.states = []
        this.macroRegion = []
        this.macroRegions = []
        this.regional = []
        this.regionalValue = ''
        this.population = []
        this.dataFilterCitiesRegion = ''
        this.dataFilterCity = null
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        this.dados = []
        this.dadosOriginaisDaRequisicao = []

        // Disabled
        this.disableStates = true
        this.disableCities = true
        this.disableMacroRegion = true
        this.disableRegional = true
      }
    },

    async onChangeStates(event) {
      this.steps = 'estado'
      this.dataFilterRegional = []
      this.regionalValue = ''
      this.disableRegional = true
      this.comEsus = false
      this.city = null
      this.dataFilterCity = null
      if (event !== null) {
        this.dataFilterMacroRegions = []
        this.dataFilterRegional = []
        this.macroRegion = []
        this.macroRegions = []
        this.population = []
        this.state = event.uf
        this.regional = []
        this.disableMacroRegion = false
        this.disableIndicador = false

        // Separa os municipios
        this.getCity()
        this.disableCities = false

        // pega as coordenadas do estado
        this.getCoordinates()

        // busca as macro regiões do estado
        this.allMacroRegionByState(this.state)
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      } else {
        this.steps = 'regiao'
        this.state = ''
        this.city = null
        this.regional = []
        this.population = []
        this.macroRegion = []
        this.macroRegions = []
        this.dataFilterMacroRegions = []
        this.dataFilterPopulation = []
        this.dataFilterRegional = []

        // Resetar Indicador
        /*   this.setIndicadorInitial() */

        // Disabled
        this.disableCities = true
        this.disableMacroRegion = true
        this.disableIndicador = true
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },

    // Popula o select de cidade
    getCity() {
      const municipios = new Set()
      if (this.macroRegion.length === 0 && this.regionalValue.length === 0) {
        this.dadosOriginaisDaRequisicao.forEach((item) => {
          if (item.no_uf === this.state) {
            municipios.add(item.no_municipio)
          }
        })
      }
      if (this.macroRegion.length !== 0) {
        this.dadosOriginaisDaRequisicao.forEach((item) => {
          if (this.regionalValue.length !== 0) {
            if (
              item.no_uf === this.state &&
              this.macroRegion.includes(item.no_macro_regiao) &&
              this.regionalValue.includes(item.no_regiao_saude)
            ) {
              municipios.add(item.no_municipio)
            }
          } else {
            if (
              item.no_uf === this.state &&
              this.macroRegion.includes(item.no_macro_regiao)
            ) {
              municipios.add(item.no_municipio)
            }
          }
        })
      }

      this.optionsCities = Array.from(municipios)
    },
    onChangeCities(event) {
      this.allMacroRegionByState(this.state)
      this.allRegionalByState(this.state, this.macroRegion)
      if (event !== null) {
        this.dataFilterCity = event
        this.disableRegional = false
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
        /*    if (this.macroRegions.length === 1) { */
        this.macroRegion = this.macroRegions
        this.disableMacroRegion = false
        this.allRegionalByState(this.state, this.macroRegions)
        /* } */
        /* if (this.regional.length === 1) { */
        this.regionalValue = this.regional
        this.disableRegional = false
        /* } */
        this.dataFilterMacroRegions = this.macroRegion
        this.dataFilterRegional = this.regionalValue
        this.getCity()
      } else {
        this.dataFilterCity = null
        this.disableMacroRegion = false
        this.disableRegional = false

        /*  this.macroRegion = []
        this.regional = [] */
        /*     this.regionalValue = '' */

        this.dataFilterMacroRegions = this.macroRegion
        this.dataFilterRegional = this.regionalValue

        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },
    onChangeMacroRegion(event) {
      this.city = null
      this.steps = 'macroRegiao'
      this.dataFilterRegional = []
      this.regionalValue = ''
      this.comEsus = false
      if (event.length > 0) {
        const dataFilterMacroRegions = []
        event.forEach((element) => {
          dataFilterMacroRegions.push(element)
        })
        dataFilterMacroRegions.push(event)
        this.dataFilterMacroRegions = dataFilterMacroRegions

        // busca as regiões do estado
        this.allRegionalByState(this.state, this.dataFilterMacroRegions)
        this.disableMacroRegion = false
        this.disableRegional = false
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
        this.getCity()
      } else {
        this.steps = 'estado'
        this.macroRegion = []
        this.disableRegional = true
        this.dataFilterMacroRegions = []
        this.regionalValue = ''
        this.dataFilterRegional = []
        this.dataFilterCity = null
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
        this.getCity()
      }
    },

    onChangeRegional(event) {
      this.city = null
      this.comEsus = false
      this.dataFilterCity = null
      if (event.length > 0) {
        this.steps = 'regional'
        const dataFilterRegional = []
        event.forEach((element) => {
          dataFilterRegional.push(element)
        })
        this.dataFilterRegional = dataFilterRegional
        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
        this.getCity()
      } else {
        this.steps = 'macroRegiao'
        this.regionalValue = ''
        this.dataFilterRegional = []
        this.dataFilterMacroRegions = this.macroRegion
        this.getCity()
        this.allMacroRegionByState(this.state)
        this.allRegionalByState(this.state, this.macroRegion)

        this.filter(
          this.dataFilterCitiesRegion,
          this.dataFilterCity,
          this.dataFilterPopulation,
          this.dataFilterMacroRegions,
          this.dataFilterRegional
        )
      }
    },
    async allCities() {
      try {
        this.loading = true
        let url = `/cofinanciamento-federal-aps/ranking/regional/ied/${this.region.value}`
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
          this.dadosOriginaisDaRequisicao = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // Buscas todos registros de todas cidades da região
    allCitiesInRegion(cities) {
      const allData = this.dadosOriginaisDaRequisicao

      const data = allData.filter((item) => {
        return cities.includes(item.no_uf)
      })
      return data
    },

    // Busca todas cidades por estado
    allCitiesByState(uf) {
      const allData = this.dadosOriginaisDaRequisicao
      const data = allData.filter((item) => {
        return item.no_uf === uf
      })
      return data
    },
    // Busca dados da cidade
    cityFilter(data) {
      const res = data.filter((item) => {
        return item.no_municipio === this.dataFilterCity
      })
      return res
    },
    // Busca todas cidades por macro região
    citiesByMacroRegions(data, uf, macroRegions) {
      const res = data.filter((item) => {
        return item.no_uf === uf && macroRegions.includes(item.no_macro_regiao)
      })
      return res
    },
    // Busca todas cidades por regional
    citiesByRegional(data, uf, regional) {
      const res = data.filter((item) => {
        return item.no_uf === uf && regional.includes(item.no_regiao_saude)
      })
      return res
    },

    citiesByPopulation(population) {
      const allData = this.allCities()
      const data = allData.filter((item) => {
        return population.includes(item.faixa_populacional)
      })
      // Passa a data e o limite de municipios
      return data
    },

    // Popula o select macroRegions
    allMacroRegionByState(uf) {
      const allData = this.dadosOriginaisDaRequisicao
      const states = allData.filter((item) => {
        if (this.city === null) {
          return item.no_uf === uf
        }
        return item.no_uf === uf && item.no_municipio === this.city
      })
      const data = []
      states.forEach((element) => {
        data.push(element.no_macro_regiao)
      })
      // removendo valores duplicados
      const result = data
        .map((e) => JSON.stringify(e))
        .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
        .map((e) => JSON.parse(e))
      this.macroRegions = result
    },

    allRegionalByState(uf, macroRegiao) {
      const allData = this.dadosOriginaisDaRequisicao
      const states = allData.filter((item) => {
        if (this.city === null) {
          return item.no_uf === uf && macroRegiao.includes(item.no_macro_regiao)
        }
        return (
          item.no_uf === uf &&
          macroRegiao.includes(item.no_macro_regiao) &&
          item.no_municipio === this.city
        )
      })
      const data = []
      states.forEach((element) => {
        data.push(element.no_regiao_saude)
      })

      // removendo valores duplicados
      const result = data
        .map((e) => JSON.stringify(e))
        .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
        .map((e) => JSON.parse(e))

      this.regional = result.filter((item) => item !== null)
    },

    getRadius(desempenho) {
      const value = parseFloat(desempenho)
      const result = value / 30
      return result
    },

    getColor(ied) {
      const iedValue = parseInt(ied)
      switch (iedValue) {
        case 1:
          return 'red'
        case 2:
          return 'orange'
        case 3:
          return 'yellow'
        case 4:
          return 'green'
        default:
          return ''
      }
    },
  },
}
</script>

<style scoped lang="scss" src="./styles.scss" />
